<div
	class="bg-green-lighter rounded-sm mt-5 py-3 flex gap-4 items-center px-10 text-sm"
>
	<app-icon [icon]="LIGHT_BULB_ICON" class="text-3xl"></app-icon>
	<span>
		Offset Treefort IDV fees with a
		<strong>$25 Stewart Title discount</strong> on eligible policy orders!
		<a
			class="font-bold hover:underline"
			href="/assets/pdf/2024/treefort/Treefort Policy Premiums July 1.pdf"
			download="stewart-treefort-promo.pdf"
			>Learn More</a
		>
	</span>
</div>
